module.exports = __webpack_public_path__ + "b69e9dbcfdbbfc76501c8f0975911600.ttf";